<template>
  <!-- WeekSheets4.vue -->
  <v-layout fill-height column>
    <div class="question" v-html="ques[0]"></div>
    <div class="answer flex-grow-0" v-if="emotionStrArr.length > 0">
      <div class="emotion-text" v-if="emotionStrArr.length > 0">
            <span v-for="item in emotionStrArr.length" :key="item" :style="{'color':emotionStrArr[item-1].color}">
                {{ emotionStrArr[item - 1].cdNm }}
              <!-- {{emotionSelectedList}} -->
            </span>
      </div>
    </div>
    <v-container flex-fill>
      <div class="pos-relative mb-5" v-if="photo !== '' && photo !== undefined && photo !== null">
        <v-img :src="$downUrl(photo)"
               aspect-ratio="2" contain class="mt-2 rounded-lg"/>
      </div>
      <div class="pos-relative mb-5" v-if="videoLink !== '' || videoAtchFileName !== null">
        <iframe v-if="videoLink"
                class="mt-2 rounded-lg"
                style="height: 40vh; width: 100%;"
                :src="'https://www.youtube.com/embed/' + videoLink.split('/').pop()"
                frameborder="0" allowfullscreen>
        </iframe>
        <video v-else-if="videoAtchFileName !== null"
               ref="video"
               class="mt-2 rounded-lg"
               controls
               width="100%"
               @click="videoPlay()">
          <source :src="$downUrl(videoAtchFileName)" type="video/mp4">
        </video>
<!--        <v-btn v-if="videoAtchFileName !== null" icon class="btn-play" @click="control">-->
<!--          <Pause :pause="pause"/>-->
<!--        </v-btn>-->
      </div>
      <Textarea
          :value="textarea"
          :counter="500"
          :placeholder=replyArr[0]
          auto-grow
          rows="3"
          @input="textareaVaule"
          :readonly="cmplt"
      />
    </v-container>
    <FooterBtnsNext @before="$emit('before')" @next="setMemberReply" :current="current" :total="total"
                    :disabledNext="disabledNext"/>
  </v-layout>
</template>
<script>
import FooterBtnsNext from "@/components/btns/FooterBtnsNext";
import Textarea from '@/components/forms/Textarea'
// import Pause from "@/components/icons/Pause"
import store from '../../../store'

export default {
  props: ["current", "total", "unitUseNo", "unitDtlUseList", "freeYn", "cmpltYn", "unitDtlUseNo", "unitDtlPageSeq", "emotionSelectedList"],
  data: () => ({
    textarea: '',
    disabledNext: true,
    free: 'N',
    cmplt: false,
    ques: [],
    replyArr: [],
    replyObjArr: [],
    userReplyNo: [0],
    userReply: [],
    // pause: true,
    videoAtchFileName: null,
    videoLink: '',
    // videoLink:'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4',
    photo: '',
    // photo:597263,
    emotionStrArr: '',
  }),
  computed: {},
  components: {
    FooterBtnsNext,
    Textarea,
    // Pause,
  },
  mounted() {
  },
  watch: {
    current() {
      // alert(this.current)
      // 동일 타입 재 조회시 초기화
      this.textarea = '',
        this.disabledNext = true,
        this.free = 'N',
        this.cmplt = false,
        this.ques = [],
        this.replyArr = [],
        this.replyObjArr = [],
        this.userReplyNo = [0],
        this.userReply = [],
        this.pause = true,
        this.videoAtchFileName = null,
        this.videoLink = '',
        this.emotionStrArr = '',
        this.getUnitDetailUse()
    }
  },
  created() {
    this.getUnitDetailUse()
  },
  methods: {
    videoPlay(){
      this.$refs.video.play();
    },
    async getUnitDetailUse() {
      this.emotionStrArr = this.emotionSelectedList
      // 무료 여부
      this.free = this.freeYn
      // 완료 여부
      this.cmplt = (this.cmpltYn === 'true' || this.cmpltYn === true) ? true : false
      // this.cmplt = true
      await store.dispatch('getUnitDetailUse', this.$_payload('so',
          [{'unitUseNo': this.unitUseNo},
            {'unitDtlUseNo': this.unitDtlUseNo[this.current - 1]},
            {'unitDtlPageSeq': this.unitDtlPageSeq[this.current - 1]},
            {'freeYn': this.free},
            {'feedbackUserKey': this.$route.query.feedbackUserKey}
          ]))
        .then(res => {
          if (res.success) {

            // 질문 리스트
            res.data.unitDtlQuesList.forEach((quesEl, i) => {

              // 질문 셋팅
              // this.ques[i] = quesEl.ques
              this.ques.push(quesEl.ques)

              if (quesEl.imgAtchFileName != null) {
                this.photo = quesEl.imgAtchFileName
              }
              if (quesEl.videoAtchFileName != null) {
                this.videoAtchFileName = quesEl.videoAtchFileName
              }
              if (quesEl.videoLink != null && quesEl.videoLink !== '') {
                this.videoLink = quesEl.videoLink
              }

              // 답변 셋팅
              quesEl.unitDtlReplyList.forEach((replyEl) => {
                // 렌더링 때문에 답변따로 먼저 저장 후 객체도 저장
                this.replyArr.push(replyEl.reply)
                this.replyObjArr.push(replyEl)
              });

              // 유저 답변 셋팅
              quesEl.memberUnitDtlReplyList.forEach((userReplyEl, j) => {
                this.userReplyNo[i + j] = userReplyEl.memberUnitDtlReplyUseNo
                this.textarea = userReplyEl.reply
                this.textareaVaule(this.textarea)
              });
            });

          } else {
            console.log(res.msg)
            // this.answer = [];
          }
        })
        .catch(error => {
          console.error(error)
          // this.answer = [];
        })
        .finally(() => {
        })
    },
    async setMemberReply() {

      if (!this.cmplt) { // 완료상태가 아닐때만 저장
        // 서술형 답변
        let replyObj = this.replyObjArr[0]
        this.userReply[0] = {
          unitId: replyObj.unitId,
          sltUnitMappingUseNo: replyObj.sltUnitMappingUseNo,

          memberUnitDtlReplyUseNo: this.userReplyNo[0],
          // unitUseNo: replyObj.unitUseNo,
          unitNo: replyObj.unitNo,
          // unitDtlUseNo: replyObj.unitDtlUseNo,
          unitDtlNo: replyObj.unitDtlNo,
          // unitDtlQuesUseNo: replyObj.unitDtlQuesUseNo,
          unitDtlQuesNo: replyObj.unitDtlQuesNo,
          // unitDtlReplyUseNo: replyObj.unitDtlReplyUseNo,
          unitDtlReplyNo: replyObj.unitDtlReplyNo,
          userKey: this.$store.state.auth.authUser.userKey,
          reply: this.textarea,
          // score: score/10,
          freeYn: this.free
        }

        await store.dispatch('setMemberReply', this.$_payload('memberReplyList', this.userReply))
          .then(res => {
            if (res.success) {
              setTimeout(() => this.$emit('next'), 500); // 저장한 이후
            } else {
              console.log(res.msg)
            }
          })
          .catch(error => {
            console.error(error)
          })
          .finally(() => {
          })
      } else {
        this.$emit('next')
      }
    },
    textareaVaule(value) {
      this.textarea = value;
      if (this.textarea.trim() == "" || this.textarea.length > 500) {
        this.disabledNext = true
      } else {
        this.disabledNext = false
      }
    },
    // control() {
    //   this.pause = !this.pause
    //   this.pause ? this.$refs.video.pause() : this.$refs.video.play()
    // }
  }
};
</script>
<style lang="scss" scoped>
.btn-play {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  width: 50px;
  height: 50px;
}
</style>
